import addElementModalTemplate from '../../../views/seats/add-element-modal.tpl.html';
import createModalTemplate from '../../../../billing/invoices/views/create-modal.tpl.html';
import moveToOtherListModalTemplate from '../../../views/seats/move-to-other-list/main-modal-template.tpl.html';
import rsvpModelReducer from '../../../helpers/rsvp-model-reducer';
import rsvpSingleMessageModalCreator from '../../../../../modules/messages/helpers/rsvp-single-message-modal-creator';

class BookingInformationModalController {
    constructor($scope, $injector, $uibModalInstance, bookingInformation, currentGroup, blockedElements, model, seatplan, guestlist, reloadCallback) {
        this.injector = $injector;
        this.scope = $scope;

        this.bookingInformation = bookingInformation;
        this.currentGroup = currentGroup;
        this.blockedElements = blockedElements;
        this.guestlist = guestlist;
        this.rsvp = model;
        this.seatplan = seatplan;
        this.reloadCallback = reloadCallback;
        this.model = rsvpModelReducer(model);

        this.modalInstance = $uibModalInstance;
        this.restangular = this.injector.get('Restangular');
        this.modal = this.injector.get('$uibModal');
        this.state = this.injector.get('$state');
        this.rootScope = this.injector.get('$rootScope');
        this.error = this.injector.get('Error');
        this.rsvpModel = this.injector.get('Rsvp');
        this.http = this.injector.get('$http');
        this.env = this.injector.get('Env');
        this.sweetAlert = this.injector.get('SweetAlert');
        this.alert = this.injector.get('Alert');
        this.user = this.injector.get('Users');
        this.fileSaver = this.injector.get('FileSaver');
        this.depositService = this.injector.get('Deposit');
        this.acl = this.injector.get('Acl');
        this.contactModel = this.injector.get('Contact');
        this.invoiceModel = this.injector.get('Invoice');
        this.translate = this.injector.get('$translate');
        this.posService = this.injector.get('PosService');
        this.allowElementMultiSelection = _.get(this.user, 'state.company.settings.seatplans.enable_multiple_bookings_per_element')
        this.timeout = this.injector.get('$timeout');
        this.blob = this.injector.get('Blob');

        this.contactSchema = {};
        this.tickets = [];
        this.newTicket = {};

        this.guestlistConfig = null;
        this.currentAreaConfigs = [];


        this.deposits = {
            rsvpStates: []
        };
        this.hasCustomInvoiceAddress = false;
        this.hasCustomShippingAddress = false;
        this.enableMoveToOtherList = false;
        this.overviewPrintRunning = false;
        this.overviewDownloadRunning = false;
        this.customTimeFieldStates = {
            custom_start_time: false,
            custom_end_time: false
        };
        this.tmpBlockedObjects = [];
        this.rsvpStates = [];
        this.currentPax = 0;
        this.editEnabled = false;
        this.currentSelectedObject = (this.rsvp.seatplan_elements.length > 0) ? this.rsvp.seatplan_elements[0] : null;
        this.currentMainTab = 'general';
        this.showAreaSelector = false;
        this.submitting = false;
        this.showSeatplanElementsBo = true;
        this.definitionsLoading = false;

        this.originalStatus = '';

        this._setSettings();
        this._loadDeposits();
        this.updateRsvpStates();
        this._checkCustomFieldClone();
        this._initWatchers();
        this._loadData();
    }

    _loadDeposits() {
        this.depositService.getRemoteDeposit('rsvps', 'states', []).then((value) => {
            this.deposits.rsvpStates = value;
            this.updateRsvpStates();
        });
    }

    async _loadData() {
        this.definitionsLoading = true;
        await Promise.all([
            this._updateRsvp(),
            this._getGuestlistConfigForSeatplanElements(),
            this.contactModel.getSchema().then((schema) => {
                this.contactSchema = schema;
                this.scope.$applyAsync();
            }),
            this._getTicketsForRsvp()
        ])

        this.definitionsLoading = false;
    }

    _updateRsvp() {
        return this.rsvpModel.one(this.rsvp.id).get({include: 'contact,contact.categories,guestlist,guestlistCombination,invoices'}).then((rsvp) => {
            if (rsvp.custom_start_time) {
                this.customTimeFieldStates.custom_start_time = true;
                rsvp.custom_start_time = new Date(rsvp.custom_start_time);
            } else {
                this.customTimeFieldStates.custom_start_time = false;
                rsvp.custom_start_time = null;
            }

            if (rsvp.custom_end_time) {
                this.customTimeFieldStates.custom_end_time = true;
                rsvp.custom_end_time = new Date(rsvp.custom_end_time);
            } else {
                this.customTimeFieldStates.custom_end_time = false;
                rsvp.custom_end_time = null;
            }


            this.rsvp = _.cloneDeep(rsvp);
            this.model = rsvpModelReducer(rsvp);

            if (this.model.invoice_address && Object.keys(this.model.invoice_address).length > 0) {
                this.hasCustomInvoiceAddress = true;
            } else {
                this.hasCustomInvoiceAddress = false;
                this.model.invoice_address = null;
            }

            if (this.model.wants_shipping
                && (this.model.shipping_address && Object.keys(this.model.shipping_address).length > 0)) {
                this.hasCustomShippingAddress = true;
            } else {
                this.hasCustomShippingAddress = false;
                this.model.shipping_address = null;
            }

            this.currentSelectedObject = (this.model.seatplan_elements.length > 0) ? this.model.seatplan_elements[0] : null;
            this.enableMoveToOtherList = (!this.rsvp.archived && !this.rsvp.guestlist_combination_id && !this.guestlist.archived);
            this.originalStatus = this.model.status
        });
    }

    declineRsvp() {
        const jobsToWaitFor = [];
        const rsvpToDecline = _.cloneDeep(this.rsvp);

        rsvpToDecline.seatplan_elements = [];
        rsvpToDecline.status = 'declined';

        jobsToWaitFor.push(this.restangular.all('rsvps').customPUT(rsvpToDecline, rsvpToDecline.id));

        const templateId = this.getStatusTemplateIdForGuestlist(this.guestlist, rsvpToDecline.status);
        if (templateId) {
            jobsToWaitFor.push(this.http.post(`messages`, this.setupMessage(this.rsvp, this.rsvp.contact.data, templateId, rsvpToDecline.status)))
        }

        Promise.all(jobsToWaitFor).then(() => {
            this._loadData();
            return this.alert.success(
                this.translate.instant('Success'),
                this.translate.instant(`RSVP successfully declined`)
            );
        }, err => {
            this._loadData();
            return this.alert.error(
                this.translate.instant('Error'),
                this.translate.instant(`Error while declining rsvp`)
            );
        });
    }

    cancelRsvp() {
        this.sweetAlert.swal({
            title: "Cancel rsvp?",
            text: "Are you sure to cancel this rsvp?",
            type: "warning",
            showCancelButton: true,
            // confirmButtonColor: colors.rsvp.status.cancelled,
            cancelButtonText: "No",
            confirmButtonText: "Yes",
            closeOnConfirm: false
        }, (confirmed) => {
            if (confirmed) {
                const jobsToWaitFor = [];
                if (this.rsvp.invoices) {
                    _.each(this.rsvp.invoices.data, (invoice) => {
                        jobsToWaitFor.push(this.http.delete('billing/invoices/' + invoice.id));
                    });
                }

                const rsvpToCancel = _.cloneDeep(this.rsvp);

                rsvpToCancel.seatplan_elements = [];
                rsvpToCancel.status = 'cancelled';

                jobsToWaitFor.push(this.restangular.all('rsvps').customPUT(rsvpToCancel, rsvpToCancel.id));

                const templateId = this.getStatusTemplateIdForGuestlist(this.guestlist, rsvpToCancel.status);
                if (templateId) {
                    jobsToWaitFor.push(this.http.post(`messages`, this.setupMessage(this.rsvp, this.rsvp.contact.data, templateId, rsvpToCancel.status)))
                }

                Promise.all(jobsToWaitFor).then(() => {
                    this.sweetAlert.swal('Cancelled', 'The rsvp was cancelled successful', 'info');
                    this._loadData();
                    this.submitting = false;
                }, (error) => {
                    this.submitting = false;
                    if (error.status === 422) {
                        if (typeof error.data.errors.seatplan_elements !== 'undefined') {
                            this.sweetAlert.swal('Error!', error.data.errors.seatplan_elements[0], 'error');
                            return;
                        } else {
                            this.sweetAlert.swal('Error!', 'A error occurred while saving . Please try again', 'error');
                            return;
                        }
                    }
                    this.sweetAlert.swal('Error!', 'A error occurred while saving . Please try again', 'error');
                });

                this.submitting = true;
            }
        });
    }


    enableEdit() {
        this.editEnabled = true;
        this.goToTab(this.model.seatplan_elements[0]);
    }

    goToContact() {
        this.dismissModal();
        this.state.go('app.contacts.details.overview', {id: this.rsvp.contact.data.id});
    }

    removeElement(element) {
        const indexToDelete = this.model.seatplan_elements.indexOf(element);

        if (indexToDelete > -1) {
            this.model.seatplan_elements.splice(indexToDelete, 1);
        }

        if (this.model.seatplan_elements.length > 0) {
            this.currentSelectedObject = this.model.seatplan_elements[0];
        } else {
            this.currentSelectedObject = null;
        }

        if (this.tmpBlockedObjects.indexOf(element.element) !== -1) {
            this.tmpBlockedObjects.splice(this.tmpBlockedObjects.indexOf(element.element), 1);
        }
    }

    updateRsvp(rsvp) {
        this.submitting = true;
        if (this._isEmptyBooking() && !this.model.seatplan_area_id) {
            this.sweetAlert.swal('Validation', 'Please select a area', 'warning');
            this.submitting = false;
            return;
        }
        if (!_.isUndefined(this.rsvpStates[this.model.status]) === -1) {
            this.sweetAlert.swal('Validation', 'Please select a valid status', 'warning');
            this.submitting = false;
            return;
        }

        this.restangular.all('rsvps').customPUT(this.model, rsvp.id).then((newRsvp) => {
            this.sweetAlert.swal('Änderungen gespeichert', 'Ihre Änderungen an der Buchung wurde gespeichert', 'success');
            this._checkForSendingStatusEmail(this.rsvp, this.rsvp.contact.data, this.originalStatus, this.model.status);
            this._loadData();

            this.editEnabled = false;
            this.submitting = false;
        }, (error) => {
            this.submitting = false;
            if (error.status === 422) {
                if (typeof error.data.errors.seatplan_elements !== 'undefined') {
                    this.sweetAlert.swal('Fehler!', error.data.errors.seatplan_elements[0], 'error');
                    return;
                } else {
                    this.sweetAlert.swal('Fehler!', 'Fehler beim speichern. Bitte erneut versuchen', 'error');
                    this.editEnabled = false;
                    return;
                }
            }
            this.sweetAlert.swal('Fehler!', 'Fehler beim speichern. Bitte erneut versuchen', 'error');
            this.editEnabled = false;
        });
    }

    moveElement(element) {
        this._startElementSelectModal(true, [element.seatplan_element_id]).then((selectedInformation) => {
            const selectedElements = selectedInformation.elements;
            if (selectedElements.length > 0) {
                const newElement = selectedElements[0];
                this.sweetAlert.swal({
                        title: 'Move booking',
                        text: 'Are you sure you want to move booking information from table ' + element.element.title + ' to table ' + newElement.title,
                        type: 'info',
                        showCancelButton: true,
                        confirmButtonColor: '#9C63FF',
                        confirmButtonText: 'Yes, move it',
                        showLoaderOnConfirm: true,
                        closeOnConfirm: false
                    },
                    (confirmed) => {
                        if (confirmed) {
                            this.restangular.all('rsvps/seatplan_elements').customPUT({
                                new_element: newElement.id
                            }, element.id + '/move').then((response) => {
                                this.sweetAlert.success('Success', 'table was moved successful');
                                let newBookingInformation;

                                this.reloadCallback()
                                    .then((bookingInformation) => {
                                        this.bookingInformation = bookingInformation
                                    });
                                // if (this.bookingInformation[element.element.id]) {
                                //     newBookingInformation = angular.copy(this.bookingInformation[element.element.id]);
                                //     newBookingInformation.element.id = newElement.id;
                                // } else {
                                //     newBookingInformation = {
                                //         id: null,
                                //         element: {
                                //             id: newElement.id,
                                //             title: newElement.title,
                                //             rsvp: this.model,
                                //             contact: this.model.contact.data
                                //         }
                                //     };
                                // }
                                //
                                // this.bookingInformation[newElement.id] = newBookingInformation;
                                // delete this.bookingInformation[element.element.id];
                                //
                                // _.each(this.model.seatplan_elements, (v, k) => {
                                //     if (v.element.id === element.element.id) {
                                //         this.model.seatplan_elements[k] = response;
                                //         this.currentSelectedObject = response;
                                //     }
                                // });
                                this.reloadInformation()
                            }, (e) => {
                                this.error.default(e);
                            });
                        }
                    });
            }
        }, () => {

        });
    }

    deleteRsvp() {
        this.sweetAlert.swal({
            title: "Delete rsvp?",
            text: "Are you sure to delete this rsvp?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#9C63FF",
            confirmButtonText: "Yes, delete it!",
            closeOnConfirm: false
        }, (confirmed) => {
            if (confirmed) {
                this.restangular.all('rsvps').customDELETE(this.rsvp.id).then(() => {
                    this.sweetAlert.swal('Gelöscht', 'Die ausgewählte Reservierung wurde erfolgreich gelöscht', 'success');
                    this.closeModal();
                }, () => {
                    this.sweetAlert.swal('Fehler!', 'Fehler beim löschen. Bitte erneut versuchen', 'error');
                    this.closeModal();
                });
            }
        });
    }

    _checkCustomFieldClone() {
        if (this.model.seatplan_elements.length === 0) {
            return false;
        }
        let strToBeEmpty = '';

        angular.forEach(this.model.seatplan_elements, (value) => {
            for (let i = 1; i <= 10; i++) {
                if (value['custom_' + i]) {
                    strToBeEmpty += value['custom_' + i];
                }
            }
        });

        this.enableCustomFieldClone = (strToBeEmpty.trim() === '');
    }

    _initWatchers() {
        this.scope.$watch(() => {
            return this.model.seatplan_elements;
        }, (val) => {
            this._checkCustomFieldClone();
            this._updateCurrentPax();
            this.updateRsvpStates();
        }, true);

        this.scope.$watch(() => {
            return this.customTimeFieldStates.custom_start_time;
        }, (val) => {
            this.toggleCustomTimeField('custom_start_time');
        }, true);

        this.scope.$watch(() => {
            return this.customTimeFieldStates.custom_end_time;
        }, (val) => {
            this.toggleCustomTimeField('custom_end_time');
        }, true);

        this.scope.$watch(() => {
            return this.currentSelectedObject;
        }, (val) => {
            this.showSeatplanElementsBo = false;
            this.timeout(() => {
                this.showSeatplanElementsBo = true;
            }, 0);
        }, true);
    }

    _updateCurrentPax() {
        let sum = 0;
        _.forEach(this.model.seatplan_elements, (v) => {
            sum += v.pax;
        });

        this.currentPax = sum;
    }

    blockRsvp(rsvp) {
        this.rsvpModel.one(rsvp.id).customGET('block').then((rsvp) => {
            this.rsvp.blocked = true;
        }, (e) => {
            this.error.default(e);
        });
    }

    unBlockRsvp(rsvp) {
        this.rsvpModel.one(rsvp.id).customGET('unblock').then((rsvp) => {
            this.rsvp.blocked = false;
        }, (e) => {
            this.error.default(e);
        });
    }

    startAddElementModal() {
        this._startElementSelectModal().then((selectedInformation) => {
            if (selectedInformation.group !== this.currentGroup) {
                this.currentGroup = selectedInformation.group;
            }
            const newRsvpsSeatplanElements = [];
            _.each(selectedInformation.elements, (selectedElement) => {
                let foundInExisting = false;
                _.each(this.model.seatplan_elements, (existingRse) => {
                    if (existingRse.seatplan_element_id === selectedElement.id) {
                        newRsvpsSeatplanElements.push(_.cloneDeep(existingRse));
                        foundInExisting = true;
                    }
                });

                if (!foundInExisting) {
                    newRsvpsSeatplanElements.push({
                        element: selectedElement,
                        seatplan_element_id: selectedElement.id,
                        pax: selectedElement.pax
                    });
                }
            });

            this.model.seatplan_elements = newRsvpsSeatplanElements;

            if (this.model.seatplan_elements.length > 0) {
                this.goToTab(this.model.seatplan_elements[0]);
            }
        }, () => {

        });
    }

    prepareBlockedElements(selectedElementIds) {
        let out
        if (this.allowElementMultiSelection) {
            out = []
        } else {
            out = _.map(this.bookingInformation, (obj, id) => {
                return parseInt(id);
            });
        }

        _.each(this.blockedElements, (v) => {
            out.push(v);
        });

        _.each(this.model.seatplan_elements, (v) => {
            out.push(v.seatplan_element_id);
        });

        return _.filter(out, (value) => (selectedElementIds.indexOf(value) === -1));
    }

    _startElementSelectModal(singleSelect, selectedElements) {
        let selectedElementIds;

        if (selectedElements) {
            selectedElementIds = selectedElements;
        } else {
            const ids = [];
            _.each(this.model.seatplan_elements, (rse) => {
                ids.push(rse.seatplan_element_id);
            });
            selectedElementIds = ids;
        }

        return this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: addElementModalTemplate,
            size: 'xlg',
            controller: 'AddElementModalController',
            resolve: {
                showGroupSelection: () => {
                    return true; //this.model.seatplan_elements.length === 0;
                },
                seatplan: () => {
                    return this.seatplan;
                },
                currentGroup: () => {
                    return this.currentGroup;
                },
                hiddenElements: () => {
                    return this.prepareBlockedElements(selectedElementIds);
                },
                bookingInformation: () => {
                    let bookingInformationForSeatplan = _.cloneDeep(this.bookingInformation);
                    if (!this.allowElementMultiSelection) {
                        _.each(selectedElementIds, (id) => {
                            if (bookingInformationForSeatplan[id]) {
                                delete bookingInformationForSeatplan[id];
                            }
                        });
                    }
                    return bookingInformationForSeatplan;
                },
                requiredPax: () => {
                    return this.model.pax_planned;
                },
                isSingleSelect: () => {
                    return !!singleSelect;
                },
                currentSelectedElementIds: () => {
                    return selectedElementIds;
                },
                allowElementMultiSelection: () => {
                    return this.allowElementMultiSelection
                }
            },
            controllerAs: 'vm'
        }).result;
    }

    _getGuestlistConfigForSeatplanElements() {
        return new Promise((resolve, reject) => {
            const seatplanElementIds = [];
            _.each(this.model.seatplan_elements, (v) => {
                seatplanElementIds.push(v.seatplan_element_id);
            });

            this.http.post('guestlists/' + this.model.guestlist_id + '/booking-definitions/' + this.model.id, {
                elements: seatplanElementIds
            }).then((result) => {
                this.guestlistConfig = result.data;

                if (this.model.guestlist_combination_id) {
                    _.each(this.guestlistConfig.available_combinations, (combination) => {
                        if (combination.id === this.model.guestlist_combination_id) {
                            this.currentAreaConfigs = combination.areas;
                        }
                    });
                } else {
                    this.currentAreaConfigs = this.guestlistConfig.areas;
                }
                this.toggleCustomTimeField('custom_start_time');
                this.toggleCustomTimeField('custom_end_time');
                resolve();
            });
        });
    }

    _getTicketsForRsvp() {
        this.tickets = [];
        if (!this.acl.hasModule('tickets')) {
            return;
        }

        return this.http.post('fp/rsvps/' + this.rsvp.id + '/tickets',
            {
                "onlyArchived": false,
                "fields": [
                    "id",
                    "rsvp.id",
                    // "rsvp.area_start_time",
                    "rsvp.seatplan_element_pax",
                    "number",
                    "pax_printed",
                    "pax_override",
                    "comment",
                    "template.name",
                    "created_at"
                ],
                sort: {
                    created_at: 'desc'
                }
            }
        ).then((result) => {
            this.tickets = result.data;
        });
    }

    createTicket() {
        const data = {
            pax_override: this.newTicket.paxOverride || 0,
            comment: this.newTicket.comment || ''
        };

        this.http.post(`tickets/create-for-rsvp/${this.rsvp.id}`, data)
            .then((result) => {
                this._getTicketsForRsvp();
                this.newTicket = {};
            });
    }

    printTicket(ticket) {
        // hide print button immediately
        this.tickets.data.find((t) => t.id === ticket.id).pax_printed = 1;

        this.http.post(`rsvps/${this.rsvp.id}/tickets/${ticket.id}/print`)
            .then((result) => this._getTicketsForRsvp());
    }

    downloadTicket(ticket) {
        // hide print button immediately
        // this.tickets.data.find((t) => t.id === ticket.id).pax_printed = 1;

        this.http.get(`rsvps/${this.rsvp.id}/tickets/${ticket.id}/download`, {responseType: "blob"})
            .then((response) => {
                    const blob = new Blob([response.data], {type: response.headers('content-type')});
                    this.fileSaver.saveAs(blob, 'ticket-' + this.rsvp.booking_number + '.pdf');
                },
                (response) => {
                    this.alert.handle(response);
                });
    }

    exportRsvpInfoDocument() {
        this.infoDocExportRunning = true;
        this.http.post(`exports/rsvps/${this.rsvp.id}/info-doc`, {})
            .then((response) => {
                this.sweetAlert.success('Print started', 'The info document print was started');
                this.infoDocExportRunning = false;
                this.reloadInformation();
            }, (response) => {
                this.sweetAlert.error('Export Error', 'There was an error while preparing the export');
                this.infoDocExportRunning
                    = false;
            });
    }

    downloadSingleOverviewDocument() {
        this.overviewDownloadRunning = true;
        this.http.get(`exports/rsvps/${this.rsvp.id}/overview-document/download`, {responseType: "blob"})
            .then(response => {
                const blob = new this.blob([response.data], {type: response.headers('content-type')});
                this.loading = false;

                this.fileSaver.saveAs(blob,
                    `${this.rsvp.booking_number}_overview.pdf`
                );
                this.overviewDownloadRunning = false;
                this.reloadInformation();
            })
            .catch(response => {
                console.log(response)
                this.sweetAlert.error('Export Error', 'There was an error while preparing the export');
                this.overviewDownloadRunning = false;
            });
    }

    printSingleOverviewDocument() {
        this.overviewPrintRunning = true;
        this.http.get(`exports/rsvps/${this.rsvp.id}/overview-document/print`)
            .then((response) => {
                this.sweetAlert.success('Print started', 'The overview print was started');
                this.overviewPrintRunning = false;
                this.reloadInformation();
            }, (response) => {
                this.sweetAlert.error('Export Error', 'There was an error while preparing the export');
                this.overviewPrintRunning = false;
            });
    }

    exportRsvpTableCards() {
        this.tableCardExportRunning = true;
        this.http.post(`exports/rsvps/${this.rsvp.id}/table-cards`, {})
            .then((response) => {
                this.sweetAlert.success('Print started', 'The table card print was started');
                this.tableCardExportRunning = false;
            }, (response) => {
                this.sweetAlert.error('Export Error', 'There was an error while preparing the export');
                this.tableCardExportRunning = false;
            });
    }

    exportRseTableCard(rse) {
        this.tableCardExportRunning = true;
        this.http.post(`exports/rsvps/${this.rsvp.id}/rse/${rse.id}/table-card`, {})
            .then((response) => {
                this.sweetAlert.success('Print started', 'The table card print was started');
                this.tableCardExportRunning = false;
            }, (response) => {
                this.sweetAlert.error('Export Error', 'There was an error while preparing the export');
                this.tableCardExportRunning = false;
            });
    }

    getLabelForBookableObjectUuid(bookableObjectUuid) {
        for (let i = 0; i < this.guestlistConfig.bookable_objects.length; i++) {
            const curBookableObject = this.guestlistConfig.bookable_objects[i];
            if (bookableObjectUuid === curBookableObject.uuid) {
                return curBookableObject.label;
            }
        }
    }

    handleBoChange(newVal) {
        this.model.bookable_objects = newVal;
    }

    handleSeatplanElementBoChange(newVal) {
        this.currentSelectedObject.bookable_objects = newVal;
    }

    sendEmailToRsvp() {
        rsvpSingleMessageModalCreator(this.injector, this.rsvp, this.rsvp.contact.data, {
            guestlist: this.guestlist
        });
    }

    goToTab(newObject) {
        this.currentSelectedObject = newObject;
    }

    goToMainTab(newTab) {
        this.currentMainTab = newTab;
    }

    closeModal() {
        this.modalInstance.close();
    }

    dismissModal() {
        this.modalInstance.dismiss();
    }

    toggleCustomTimeField(field) {
        if (this.customTimeFieldStates[field]) {
            if (Object.keys(this.currentAreaConfigs).length > 0 && !this.model[field]) {
                if (field === 'custom_start_time') {
                    this.model[field] = new Date(this.currentAreaConfigs[Object.keys(this.currentAreaConfigs)[0]].start);
                } else if (field === 'custom_end_time') {
                    this.model[field] = new Date(this.currentAreaConfigs[Object.keys(this.currentAreaConfigs)[0]].end);
                }
            }
        } else {
            this.model[field] = null;
        }
    }

    updateRsvpStates() {
        if (this._isEmptyBooking()) {
            this.showAreaSelector = true;
        } else {
            this.showAreaSelector = false;
        }

        this.rsvpStates = this.deposits.rsvpStates;
    }

    _isEmptyBooking() {
        return !this.model.seatplan_elements || this.model.seatplan_elements.length === 0;
    }

    checkInvoiceAddressState() {
        if (this.hasCustomInvoiceAddress) {
            if (!this.model.invoice_address) {
                this.model.invoice_address = {
                    salutation: 'Herr',
                    first_name: '',
                    last_name: '',
                    company_name: '',
                    street: '',
                    city: '',
                    zip: '',
                    country: 'DE'
                };
            }
        } else {
            this.model.invoice_address = null;
        }
    }

    checkShippingAddressState() {
        if (this.model.wants_shipping && this.hasCustomShippingAddress) {
            if (!this.model.shipping_address) {
                this.model.shipping_address = {
                    salutation: 'Herr',
                    first_name: '',
                    last_name: '',
                    company_name: '',
                    street: '',
                    city: '',
                    zip: '',
                    country: 'DE'
                };
            }
        } else {
            this.model.shipping_address = null;
        }
    }

    reloadInformation() {
        this._loadData();
    }

    _setSettings() {
        this.enableSeatplanElementsBo = _.get(this.user, 'state.company.settings.seatplans.enable_seatplan_elements_bookable_objects', false);
        this.enableStatusEmailFlow = _.get(this.user, 'state.company.settings.seatplans.enable_rsvp_status_email_on_seatplan_status_change', false);
        this.enableSeatplanCancelButton = _.get(this.user, 'state.company.settings.seatplans.enable_cancel_rsvp_on_booking_modal', false);
        this.enableMigrateToNewYear = _.get(this.user, 'state.company.settings.rsvps.enable_year_migration', false);
        this.enableConsumptions = _.get(this.user, 'state.company.settings.rsvps.enable_consumptions', false);
        this.showConsumptionTip = _.get(this.user, 'state.company.settings.rsvps.show_consumption_tip', false);
        this.billableRsvpStates = _.get(this.user, 'state.company.settings.billing.billable_rsvp_states', false);
        this.posIsEnabled = _.get(this.user, 'state.company.settings.billing.pos_enabled', false);
    }

    goToInvoiceDetails(invoice) {
        this.state.go('app.billing.invoices.details', {id: invoice.id});
        this.modalInstance.close();
    }

    prepareUpcomingShippingInformation() {
        this.http.post('contacts/prepare-shipping-for-upcoming', {
            contacts: {
                filters: [{field: 'id', operator: '=', value: this.rsvp.contact_id}],
                count: 1
            }
        }).then(() => {
            this.sweetAlert.success('Success', 'Shipping addresses have been prepared');
        }, () => {
            this.sweetAlert.error('Error', 'Prepare shipping addresses failed');
        });
    }

    createNewInvoice() {
        this.createNewDocument('invoice');
    }

    createNewPosInvoice() {
        this.posService.openPosModal(this.rsvp.contact.data.id, this.rsvp.id, this.rsvp.seatplan_element_pax)
            .then(() => {
                this.closeModal()
            });
    }

    createNewBid() {
        this.createNewDocument('bid');
    }

    createNewCancellation() {
        this.createNewDocument('cancellation');
    }

    createNewDocument(type) {
        const modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title-bottom',
            ariaDescribedBy: 'modal-body-bottom',
            templateUrl: createModalTemplate,
            size: 'xlg',
            controller: 'InvoicesCreateModalCtrl',
            controllerAs: 'vm',
            resolve: {
                type: () => {
                    return type;
                },
                entity: () => {
                    return {
                        contactId: this.rsvp.contact.data.id,
                        id: this.rsvp.id,
                        type: 'rsvp'
                    };
                }
            }
        }).result.then(() => {
            this._loadData();
        });
    }

    downloadInvoice(invoice) {
        if (invoice.status === 'draft') {
            return this.invoiceModel.downloadInvoice(invoice.id, 'invoice-' + invoice.id + '-draft.pdf');
        } else {
            return this.invoiceModel.downloadInvoice(invoice.id, 'invoice-' + invoice.invoice_number + '.pdf');
        }
    }

    sendInvoice(invoice) {
        return this.invoiceModel.sendInvoice(invoice, this.rsvp.contact.data);
    }

    deleteInvoice(invoice) {
        this.sweetAlert.swal({
            title: "Delete document?",
            text: "Are you sure to delete this document?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#9C63FF",
            confirmButtonText: "Yes, delete it!",
            closeOnConfirm: false
        }, (confirmed) => {
            if (confirmed) {
                return this.invoiceModel.one(invoice.id).remove().then((response) => {
                    this.sweetAlert.swal('Success', 'invoice deleted', 'success');
                    this.reloadInformation();
                }, (e) => this.error.default(e));
            }
        });
    }

    moveBookableObjectsToSeatplanElements() {
        _.each(this.model.seatplan_elements, (seatplanElement) => {
            seatplanElement.bookable_objects = _.cloneDeep(this.model.bookable_objects);
        });
        this.model.bookable_objects = {};
    }

    moveToOtherList() {
        this.modal.open({
            templateUrl: moveToOtherListModalTemplate,
            controller: 'MoveToOtherListMainController',
            controllerAs: 'vm',
            resolve: {
                rsvp: () => {
                    return this.rsvp;
                }
            },
            size: 'lg'
        }).result.then(() => {
            this.modalInstance.dismiss();
        })
    }

    addTextBlock(customFieldNumber, textBlock) {
        this.model[`custom_${customFieldNumber}`] =
            ((this.model[`custom_${customFieldNumber}`] ? _.clone(this.model[`custom_${customFieldNumber}`]) : '') + '\n'
                + textBlock.content
                    .replace('##SEATPLAN_ELEMENT_COUNT##', this.model.seatplan_elements.length > 0 ? this.model.seatplan_elements.length : 0)
                    .replace('##SEATPLAN_ELEMENT_PAX##', this.model.seatplan_element_pax)
            ).trim();
    }

    // Functions for status email
    _checkForSendingStatusEmail(rsvp, contact, oldStatus, newStatus) {
        if (!this.enableStatusEmailFlow
            || oldStatus === newStatus
            || !this.existEmailTemplateForStatus(this.guestlist, newStatus)) {
            return;
        }

        this.alert.animatedAlert(
            this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.title'),
            this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.content', {
                email_status: this.formatEmailType(newStatus),
                contact_full_name: contact.full_name,
                contact_email: contact.preferred_email
            }),
            'attention',
            {
                confirmButtonText: this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.confirm'),
                cancelButtonText: this.translate.instant('rsvps.helpers.rsvps-status-email-helper.ask-email-pop-up.cancel')
            }
        ).then(
            () => {
                return this.http.post(`messages`, this.setupMessage(rsvp, contact, this.getStatusTemplateIdForGuestlist(this.guestlist, newStatus), newStatus))
                    .then(
                        () => {
                            this.alert.success(
                                this.translate.instant('rsvps.helpers.rsvps-status-email-helper.message_sent.title'),
                                this.translate.instant('rsvps.helpers.rsvps-status-email-helper.message_sent.content')
                            );
                        },
                        response => {
                            this.alert.handle(response);
                        }
                    );
            },
            () => {

            })
    }

    setupMessage(rsvp, contact, templateId, status) {
        return {
            type: 'email',
            send_to_override: contact.preferred_email,
            recipient_type: 'rsvp',
            rsvps: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [rsvp.id]
                    }
                ],
                count: 1
            },
            templates: {
                filters: [
                    {
                        field: 'id',
                        operator: 'IN',
                        value: [templateId]
                    }
                ],
                count: 1
            },
            attach_ticket: false,
            attach_passbook: false,
            attach_files: false,
            attach_invoice: false
        };
    }

    existEmailTemplateForStatus(guestlist, status) {
        return !_.isNull(this.getStatusTemplateIdForGuestlist(guestlist, status));
    }

    getStatusTemplateIdForGuestlist(guestlist, status) {
        const filteredGuestlistTemplates = _.filter(guestlist.templates, template => (template.status === status));

        if (filteredGuestlistTemplates.length > 0) {
            return _.get(_.first(filteredGuestlistTemplates), 'template_id', null);
        }

        return null;
    }

    formatEmailType(status) {
        let formattedEmailType = status.substring(0, status.length - 2) + 'ation';

        if (status === 'waitlisted' || status === 'requested') {
            formattedEmailType = status.substring(0, status.length - 2);
        } else if (status === 'declined') {
            formattedEmailType = 'decline';
        }

        return formattedEmailType.charAt(0).toUpperCase() + formattedEmailType.slice(1);
    }
}


BookingInformationModalController.$inject = [
    '$scope',
    '$injector',
    '$uibModalInstance',
    'bookingInformation',
    'currentGroup',
    'blockedElements',
    'model',
    'seatplan',
    'guestlist',
    'reloadCallback'
];

/**
 * @ngdoc object
 * @name guestlists.controller:BookingInformationModalController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.guestlists')
    .controller('BookingInformationModalController', BookingInformationModalController);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/controllers/guestlists/seats/booking-information-modal-controller.js